export default __webpack_public_path__ + "static/media/brc_logo.809f2f5a.jpg";